import React, { createRef, forwardRef } from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import Accordion, { type AccordionProps } from "@mui/material/Accordion";
// import MUIAccordianProps from "../../../interface";

// Every prop is spread onto MUI's `Accordion`; `border`/`borderRadius` are read here to
// build the `sx` below. `sx` also admits `false` because a caller writes `sx={cond && {...}}`.
type AccordianProps = Omit<AccordionProps, "children" | "sx"> & {
  children?: React.ReactNode;
  border?: string;
  borderRadius?: string;
  sx?: AccordionProps["sx"] | false;
};

const Accordian = forwardRef((props: AccordianProps, ref: React.ForwardedRef<HTMLElement>) => {
  const accordianRef = ref || createRef<HTMLElement>();

  return (
    <Accordion
      {...props}
      className={props.className}
      ref={accordianRef as React.Ref<HTMLDivElement>}
      disableGutters={true}
      classes={{ region: "h-full" }}
      sx={
        {
          boxShadow: "none",
          border: props.border ? props.border : "",
          borderRadius: props.borderRadius ? `${props.borderRadius} !important` : "",
          "&::before": {
            height: "0", //For removing extra top line
          },
          "&.MuiPaper-root": {
            height: "auto",
          },
          "& .MuiAccordionDetails-root": {
            height: "100%",
            width: "100%",
            padding: "0.5rem",
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: 0,
            transform: "translateY(-0.25rem)",
          },
          "& .MuiAccordionSummary-root": {
            width: "100%",
            padding: "0",
          },
          "& .MuiAccordionSummary-content": {
            width: "100%",
            margin: 0,
          },
          "& .MuiButtonBase-root.MuiListItemButton-root.Mui-selected": {
            backgroundColor: "#CAECFF",
          },
          "&.Mui-expanded .MuiAccordionDetails-root": {
            opacity: 1,
            transform: "translateY(0)",
          },
          ...props.sx,
        } as SxProps<Theme>
      }
    >
      {props.children as NonNullable<React.ReactNode>}
    </Accordion>
  );
});
Accordian.displayName = "Accordian";
export default Accordian;
